import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();
const ORDER = ['es', 'en', 'he'];

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const stored = localStorage.getItem('language');
    return ORDER.includes(stored) ? stored : 'es';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
    document.documentElement.dir = language === 'he' ? 'rtl' : 'ltr';
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => ORDER[(ORDER.indexOf(prev) + 1) % ORDER.length]);
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    isRTL: language === 'he'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
